import React from "react";
import { connect } from "react-redux";
import { withTheme } from "../../../themes/theming";
import { downloadUsedCarsTemplate } from "../../../actions/bulkUploadAction.jsx";
import { withRouter } from "react-router-dom";
import DownloadPanelUC from "./downloadPanelUC.jsx";
var I18n = require("react-redux-i18n").I18n;

class SearchFilterUC extends React.Component {
    /* eslint-disable */
    constructor(props) {
        super(props);
        this.state = {
            downloadDto: {
                role: this.props.user.userMdl.roles,
                roleFlag: false,
                nmscCode: this.props.user.userMdl.nmsc,
                loggedInUser: this.props.user.userMdl.username,
                toolboxId: null,
                toolboxName: null,
                userId: this.props.user.userMdl.username,
                status: null,
                score: null,
                activityId: null,
                loginId: null,
                dealerId: null,
                type: 'TME',
                langCode: this.props.user.userMdl.lang,
                rows: 10,
                page: 1,
                programID: this.props.user.userMdl.activeProgramID,
                program: this.props.user.userMdl.activeProgram,
                isValueChain: this.props.user.userMdl.flagValueChain,
                isBRiT: this.props.user.userMdl.flagBRiT,
                isCEA: this.props.user.userMdl.flagCEA,
                isEA: this.props.user.userMdl.flagEA,
                businessArea: this.props.user.userMdl.businessAreaKey === "EA" ? "EA" : this.props.user.userMdl.businessAreaKey
            },
        };
    }

    onClickUpload = (e) => {
        const role = this.props.user.userMdl.roles.includes("KET TME Admin") ? "KET TME Admin" : "KET NMSC Admin";
        const nmsc = this.props.user.userMdl.nmsc
        this.props.dispatch(downloadUsedCarsTemplate(role, nmsc))
    }

    render() {
        return (
            <div className="col-md-12" style={{ padding: "0px" }}>
                <div style={{ borderColor: this.props.theme.primaryColor }} className="col-md-12 searchActivity">
                    <div className="col-md-12 input-group control-label">
                        {/* Download template */}
                        <div className="col-md-12" style={{ textAlign: "right" }}>
                            <button className={"button-" + this.props.theme.name}
                                onClick={() => this.onClickUpload()} >
                                {I18n.t('tmeAdminMaster.downloadTemplate')}
                            </button>
                        </div>
                        {/* This component is for used car's listing page after generating the templete*/}
                        {/* <DownloadPanelUC data={this.props.bulkUpload.uploadQuestionnaireFileList} downloadDto={this.state.downloadDto} /> */}
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        blocking: state.loginReducer,
        router: state.routing,
        toolboxByType: state.leftNavReducer,
        bulkUpload: state.bulkUploadReducer

    };
};
export default withRouter(connect(mapStateToProps)(withTheme(SearchFilterUC)));
